"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var Step1_1 = __importDefault(require("./Step1"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var navigation_1 = require("next/navigation");
var SetNewResetPassword = function (_a) {
    var withLabels = _a.withLabels;
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var token = searchParams.get('token');
    if (!token)
        return null;
    return (react_1.default.createElement(ui_components_1.Modal, { width: "320px", height: "auto", onClose: closeWindow },
        react_1.default.createElement(ui_components_1.ModalTitle, null,
            react_1.default.createElement("span", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                    __html: t('setNewPassword'),
                } })),
        react_1.default.createElement(Step1_1.default, { withLabels: withLabels, token: token })));
};
exports.default = SetNewResetPassword;
